import { Image, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { styles } from './styles';
import { globalStyles } from '@composites/PDF/AgendaPdfContent/styles';
import { getImageSrc } from '@utils/fn';
import { useMemo } from 'react';
import { SafeImage } from '../SafeImage';

interface AlreadyRegisteredProps {
  event: PublicEventDetailsResponse;
  advertisements: any[] | undefined;
}

const AlreadyRegistered = ({
  event,
  advertisements,
}: AlreadyRegisteredProps) => {
  const { t } = useTranslation();

  const eventStatisticsItems = useMemo(
    () =>
      event?.website_content?.statistics
        ?.filter(Boolean)
        ?.sort(
          (a: any, b: any) => Number(a?.order ?? 0) - Number(b?.order ?? 0)
        )
        ?.map((stat: any) => ({
          description: String(stat?.description ?? ''),
          title: String(stat?.value ?? ''),
          icon: String(stat?.icon ?? '')
            .split('-')
            .join('_'),
        })),
    [event?.website_content?.statistics]
  );

  if (!advertisements) return;

  return (
    <View style={styles.body}>
      <Text style={{ ...globalStyles.mediumTitle, color: 'white' }}>
        {t('expected-target-groups')}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: 'white',
        }}
      />
      <View style={styles.statisticsGrid}>
        {eventStatisticsItems?.length > 0 &&
          eventStatisticsItems?.map((item, index) => (
            <View key={index} wrap={false} style={styles.statisticsItem}>
              <Text style={styles.icon}>{'\uf276'}</Text>
              <View style={styles.textWrapper}>
                <Text style={styles.statTitle}>{item.title}</Text>
                <Text style={styles.statDescription}>{item.description}</Text>
              </View>
            </View>
          ))}
      </View>

      <Text style={{ ...globalStyles.mediumTitle, color: 'white' }}>
        {t('already-registered')}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: 'white',
        }}
      />
      <View style={styles.logoGrid}>
        {advertisements?.length > 0 &&
          advertisements
            ?.filter(ad => ad?.company?.logo)
            ?.slice(0, 12)
            ?.map((ad, index) => (
              <View key={index} wrap={false} style={styles.logoWrapper}>
                <SafeImage
                  src={getImageSrc(ad?.company?.logo ?? '')}
                  style={styles.logoImage}
                  debugLabel={`advertisement-logo-${index}`}
                />
              </View>
            ))}
      </View>
    </View>
  );
};

export default AlreadyRegistered;
